import React from 'react'
import withTranslations from 'support/hoc/withTranslations'
import { observer } from 'mobx-react'
import { File as BaseFile } from '@morningtrain/react-fields'
import { useValue, WhenModelValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'

function File (props) {
  const {
    className
  } = props

  const classNames = [
    'file-wrapper',
    'file-wrapper--file',
    className
  ]

  return (
    <BaseFile {...props} className={classNames.join(' ')}>
      <WhenModelValue name={props.name}>
        <label className='float-right space-x-4 mt-3'>
          <span>
            <Translation name='generic.remove_file' />
          </span>
          <input type='checkbox' name={props.name} value='remove' />
        </label>
      </WhenModelValue>
      {props.children}
    </BaseFile>
  )
}

export default observer(withTranslations(File))
